const SubmitForm = () => {
  const link = (scope, element, attrs) => {
    scope.$on('SubmitInvoiceForm', (event, data) => {
      if (data.formName === attrs.name) {
        element.submit()
      }
    })
  }
  return { link }
}

export default SubmitForm



// WEBPACK FOOTER //
// ./src/app/common/validators/submit-form.js